export { default } from './components/View'
